// extracted by mini-css-extract-plugin
export default {"select":"waXNCU2m_HhMoDpwMeL5","flag":"_CClWAWsCBxgXzAJ4JO8","language":"u6DQQBE0Ufu85VOLKFQT","language__name":"BvucYP1zj2ifQE3c7vVZ"};
    if(module.hot) {
      // 1769430874044
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  